import SkipBackButton from './SkipBackButton';

export default SkipBackButton;
